import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sortByPropName'
})

export class SortByPropNamePipe implements PipeTransform {
    transform(items: any[], propName: string): any {
        return items.sort((a, b) => a[propName].localeCompare(b[propName]))
    }
}